<div class="dialog-container">
  <div class="dialog-header" [class.dialog-header-logout]="confirmStyle === 'primary'">
    <h2 class="dialog-title">{{ data.title }}</h2>
    <button type="button" class="btn-icon close-btn" (click)="onCancel()" aria-label="Fermer">
      ✕
    </button>
  </div>
  
  <div class="dialog-content">
    <div class="dialog-icon">{{ icon }}</div>
    <p class="dialog-message">{{ data.message }}</p>
    <p class="dialog-warning" *ngIf="showWarning">{{ data.warningText }}</p>
  </div>
  
  <div class="dialog-actions">
    <button type="button" class="btn btn-secondary" (click)="onCancel()">
      Annuler
    </button>
    <button
      type="button"
      class="btn btn-primary"
      [class.confirm-danger]="confirmStyle === 'danger'"
      [class.confirm-primary]="confirmStyle === 'primary'"
      (click)="onConfirm()">
      {{ confirmIcon }} {{ confirmLabel }}
    </button>
  </div>
</div>
